var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGithub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.795 36.5942V33.3563C29.8373 32.8184 29.7647 32.2776 29.5818 31.7699C29.3988 31.2622 29.11 30.7992 28.7345 30.4117C32.277 30.0168 36.0001 28.6743 36.0001 22.5143C35.9997 20.9391 35.3939 19.4244 34.3078 18.2835C34.8221 16.9054 34.7857 15.3822 34.2062 14.0302C34.2062 14.0302 32.875 13.6354 29.795 15.7C27.2091 14.9991 24.4834 14.9991 21.8976 15.7C18.8176 13.6354 17.4863 14.0302 17.4863 14.0302C16.9069 15.3822 16.8705 16.9054 17.3848 18.2835C16.2905 19.4329 15.684 20.9613 15.6925 22.5481C15.6925 28.663 19.4155 30.0056 22.9581 30.4455C22.5869 30.8291 22.3007 31.2866 22.1179 31.788C21.9352 32.2895 21.8601 32.8239 21.8976 33.3563V36.5942",
    stroke: "#FEFEFE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8974 34.3375C18.5128 35.4354 15.6923 34.3375 14 30.9529",
    stroke: "#FEFEFE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.748cd35d45c8936cfb7ab71440a1d52b.svg";
export { ForwardRef as ReactComponent };